<template>
  <UiContainer class="terms-view" :max-width="800">
    <h1 class="terms-view__title">Правила использования сервиса</h1>

    <div class="terms-view__body">
      <p>
        Настоящие Правила определяют порядок использования сервиса «ЛабАктив» - B2B-платформы для
        поиска оборудования, материалов и расходников.
      </p>

      <h2>1. Статус сервиса</h2>
      <p>
        Сервис находится на этапе развития. Информация о товарах, поставщиках, ценах и наличии
        предоставляется для ознакомления и требует подтверждения поставщиком до заключения сделки.
      </p>

      <h2>2. Регистрация и учетная запись</h2>
      <p>При регистрации пользователь обязуется:</p>
      <ul>
        <li>предоставлять достоверную и актуальную информацию;</li>
        <li>обеспечивать безопасность пароля;</li>
        <li>не передавать доступ к учётной записи третьим лицам.</li>
      </ul>

      <h2>3. Предложения поставщиков</h2>
      <p>
        Размещение товара или предложения на платформе не является публичной офертой. Окончательные
        цена, доступность, состав поставки, сроки и иные существенные условия подтверждаются
        поставщиком отдельно.
      </p>

      <h2>4. Договоры, доставка и расчёты</h2>
      <p>
        На текущем этапе ЛабАктив не выступает продавцом товаров, перевозчиком или платёжным
        агентом. Условия договора, доставки, оплаты, гарантий и возврата определяются сторонами
        конкретной сделки и применимым законодательством.
      </p>

      <h2>5. Работа с информацией</h2>
      <ul>
        <li>Пользователь самостоятельно проверяет условия конкретного предложения до сделки.</li>
        <li>
          Сведения на платформе могут уточняться поставщиком, поэтому их необходимо подтвердить до
          заключения договора.
        </li>
      </ul>

      <h2>6. Контакты</h2>
      <p>
        По всем вопросам обращайтесь: <a href="mailto:info@labactive.ru">info@labactive.ru</a><br />
        Телефон: <a href="tel:+79518520624">+7 (951) 852-06-24</a>
      </p>

      <p class="terms-view__updated">Редакция от 08.09.2026</p>
    </div>
  </UiContainer>
</template>

<script setup lang="ts">
import UiContainer from '@/shared/ui/UiContainer.vue'
</script>

<style scoped>
.terms-view {
  padding-top: 24px;
  padding-bottom: 48px;
}

.terms-view__title {
  margin: 0 0 24px;
  font-size: 24px;
  font-weight: 700;
}

.terms-view__body {
  line-height: 1.7;
  font-size: 15px;
}

.terms-view__body p {
  margin: 0 0 16px;
}

.terms-view__body h2 {
  margin: 32px 0 12px;
  font-size: 18px;
  font-weight: 600;
}

.terms-view__body ul {
  margin: 0 0 16px;
  padding-left: 20px;
}

.terms-view__body li {
  margin-bottom: 8px;
}

.terms-view__body a {
  color: #0f172a;
  font-weight: 500;
  text-decoration: none;
}

.terms-view__body a:hover {
  text-decoration: underline;
}

.terms-view__updated {
  margin-top: 32px;
  font-size: 14px;
  color: #586578;
}
</style>
